"use client";
import { SiteServices } from "@/interfaces/ISiteServices";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AppState {
  darkMode: boolean;
  userAgent: "Mac OS" | "iOS" | "Windows" | "Android" | "Linux" | null;
  siteServices: SiteServices[];
  stripePayment: boolean;
  superPayment: boolean;
  superPaymentTest: boolean;
}

const initialState: AppState = {
  darkMode: false,
  userAgent: null,
  siteServices: [],
  stripePayment: false,
  superPayment: false,
  superPaymentTest: false,
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    toggleDarkMode: (state) => {
      state.darkMode = !state.darkMode;
      localStorage.setItem("darkMode", state.darkMode.toString());
    },
    hydrateApp(state, action: PayloadAction<AppState>) {
      return { ...state, ...action.payload };
    },
    setSiteServices: (state, action: PayloadAction<SiteServices[]>) => {
      state.siteServices = action.payload;
      appSlice.caseReducers.postUpdate(state);
    },

    postUpdate(state) {
      state.stripePayment = state.siteServices.includes("stripe");
      state.superPayment = state.siteServices.includes("superpayment");
      state.superPaymentTest = state.siteServices.includes("superpayment-test");
    },
    setUserAgentAuto: (state) => {
      const userAgent = window.navigator.userAgent;
      const platform = window.navigator.platform;
      const macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"];
      const windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"];
      const iosPlatforms = ["iPhone", "iPad", "iPod"];

      let os: "Mac OS" | "iOS" | "Windows" | "Android" | "Linux" | null = null;

      if (macosPlatforms.indexOf(platform) !== -1) {
        os = "Mac OS";
      } else if (iosPlatforms.indexOf(platform) !== -1) {
        os = "iOS";
      } else if (windowsPlatforms.indexOf(platform) !== -1) {
        os = "Windows";
      } else if (/Android/.test(userAgent)) {
        os = "Android";
      } else if (!os && /Linux/.test(platform)) {
        os = "Linux";
      }

      state.userAgent = os;
    },
  },
});

export const { hydrateApp, toggleDarkMode, postUpdate, setSiteServices, setUserAgentAuto } =
  appSlice.actions;

export default appSlice.reducer;
